import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent } from 'react';

import Breadcrumbs from '../../modules/breadcrumbs';
import PageTitle from '../../ui/typography/page-title';

import LegalAddresses from './addresses';
import LegalContacts from './contacts';
import LegalInfo from './info';
import LegalSchema from './seo';

const LegalPage: FunctionComponent<TPageLegal> = ({}) => {
  const { t } = useTranslation();

  return (
    <main>
      <LegalSchema breadcrumbs={[]} />
      <Breadcrumbs items={[]} currentPage={t('common:legal')} />
      <div className="container mx-auto px-4 lg:mt-12 mt-4">
        <PageTitle title={t('common:legal')} />
      </div>
      <section className="container mx-auto px-4 mt-8">
        <LegalAddresses />
      </section>
      <section className="mt-8">
        <LegalContacts />
      </section>
      <section className="container mx-auto px-4 mb-12">
        <LegalInfo />
      </section>
    </main>
  );
};

export default LegalPage;
